// Module
var code = "<select class=\"form-control\" ng-model=\"data.currentNetwork\" ng-options=\"option.id as option.name for option in data.networks\"> <option value=\"\">-- Choisir le réseau --</option> </select> ";
// Exports
export default code;